// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { getProductLineProductNumber } from "@store/Framework/Common/Utilities/productLineUtilities";
import { ProductLineComponentModel } from "@store/Library/Components/ProductLine/ProductLine";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductLinePartNumbersProps {
    productLine: ProductLineComponentModel;
    showLineNumber?: boolean;
    showProductNumber?: boolean;
}

export interface ProductLinePartNumbersStyles {
    productPartNumbers?: ProductPartNumbersStyles;
}

const valueTextProps: TypographyPresentationProps = {
    css: css`
        white-space: normal;
    `,
};

export const productLinePartNumbersStyles: ProductLinePartNumbersStyles = {
    productPartNumbers: {
        wrapper: {
            css: css`
                ${spacingStyles(null, pxToRem(6))}
                font-size: ${x => x.theme.design.typography.size.smaller};
            `,
        },
        innerWrapper: {
            css: css`
                ${inlineSeparatorStyles({ spacing: "1em", color: "text.accent" })}

                &::after {
                    top: 0.18em;
                    transform: none;
                }

                ${breakpoint("xs", "down")} {
                    display: flex;

                    &::after {
                        display: none;
                    }
                }
            `,
        },
        customerNameValueText: valueTextProps,
        erpNumberValueText: valueTextProps,
        lineNumberValueText: valueTextProps,
        manufacturerItemValueText: valueTextProps,
    },
};

const styles = productLinePartNumbersStyles;

const ProductLinePartNumbers: FC<ProductLinePartNumbersProps> = ({
    productLine,
    showLineNumber,
    showProductNumber = true,
}) => {
    if (!productLine) {
        return null;
    }

    return (
        <ProductPartNumbers
            cartLineNumber={productLine.lineNumber || productLine.line}
            customerProductNumber={productLine.customerProductNumber || productLine.customerName}
            extendedStyles={styles.productPartNumbers}
            manufacturerItem={productLine.manufacturerItem}
            productNumber={getProductLineProductNumber(productLine)}
            showLineNumber={showLineNumber}
            showProductNumber={showProductNumber}
        />
    );
};

export default ProductLinePartNumbers;
